import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.602 11.566a.74.74 0 010 .867C20.54 13.924 16.73 18.75 12 18.75s-8.532-4.828-9.593-6.318a.74.74 0 010-.864C3.468 10.078 7.27 5.25 12 5.25c4.73 0 8.54 4.826 9.602 6.316z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.602 11.566a.74.74 0 010 .867C20.54 13.924 16.73 18.75 12 18.75s-8.532-4.828-9.593-6.318a.74.74 0 010-.864C3.468 10.078 7.27 5.25 12 5.25c4.73 0 8.54 4.826 9.602 6.316z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 24a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.204 23.133a1.48 1.48 0 010 1.734C41.078 27.847 33.46 37.5 24 37.5c-9.462 0-17.064-9.656-19.186-12.636a1.48 1.48 0 010-1.73C6.936 20.155 14.538 10.5 24 10.5c9.46 0 17.078 9.652 19.204 12.632z",
    clipRule: "evenodd"
  }))
};
export var Show = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});